import { render, staticRenderFns } from "./client-list.vue?vue&type=template&id=089778fe&scoped=true"
import script from "./client-list.vue?vue&type=script&lang=js"
export * from "./client-list.vue?vue&type=script&lang=js"
import style0 from "./client-list.vue?vue&type=style&index=0&id=089778fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "089778fe",
  null
  
)

export default component.exports